import { useLayoutEffect, useRef, useState } from 'react';
import { corrigeTout } from '../lib/correcteur';
import { CorrectionFaite } from './CorrectionFaite.jsx';
import { C } from '../theme/palette';

/** Hauteur minimale de la case : huit lignes environ. */
const HAUTEUR_MIN = 180;

/**
 * La description d'un article, dans une grande case qui s'agrandit toute
 * seule pour montrer tout le texte : le patron relisait une description de
 * vingt lignes dans une case de deux.
 *
 * @param {object} props propriétés
 * @param {string} props.value texte
 * @param {(texte: string) => void} props.onChange reçoit le texte modifié
 * @param {string} [props.placeholder] texte d'aide
 * @param {number} [props.fontSize] taille du texte
 * @returns {import('react').ReactElement} la case
 */
export function ChampDescription({ value, onChange, placeholder, fontSize = 14 }) {
  const ref = useRef(null);
  // Les mots du métier mal tapés ou mal dictés se corrigent à la sortie de
  // la case ; le texte tapé se retrouve d'un toucher sur « Annuler ».
  const [correction, setCorrection] = useState(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.max(HAUTEUR_MIN, el.scrollHeight + 2) + 'px';
  }, [value]);
  return (
    <>
      <textarea
        ref={ref}
        value={value || ''}
        onChange={(e) => {
          setCorrection(null);
          onChange(e.target.value);
        }}
        onBlur={() => {
          const r = corrigeTout(value || '');
          if (r.corrections.length === 0) return;
          setCorrection({ avant: value, corrections: r.corrections });
          onChange(r.texte);
        }}
        spellCheck
        autoCorrect="on"
        placeholder={placeholder}
        aria-label="Description"
        style={{
          width: '100%',
          minHeight: HAUTEUR_MIN,
          border: '1px solid ' + C.border,
          borderRadius: 9,
          padding: 10,
          fontSize,
          lineHeight: 1.45,
          fontFamily: 'inherit',
          resize: 'vertical',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
      />
      <CorrectionFaite
        corrections={correction?.corrections}
        onAnnule={() => {
          onChange(correction.avant);
          setCorrection(null);
        }}
      />
    </>
  );
}
